'use client'
import {
  Col,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'
import { BalanceProjectHistory } from './balance-project.history'
import { useTranslate } from '@repo/shared/hooks'
import { BalanceProjectTransferHistory } from './balance-project.transfer.history'
import { BalanceContainer } from '../balance.container'
import { useSearchParams } from 'next/navigation'

export const BalanceProjectAllContainer = () => {
  const { t } = useTranslate()
  const searchParams = useSearchParams()
  const type = searchParams.get('type')
  const defaultValue = type === 'transfer' ? 'transfer' : 'depositAndWithdraw'
  const tabs = [
    {
      value: 'depositAndWithdraw',
      label: t('walletPage_history_deposit_and_withdraw_all'),
    },
    {
      value: 'sellAndBuy',
      label: t('walletPage_history_sell_and_buy_all'),
    },
    {
      value: 'transfer',
      label: t('walletPage_history_transfer_all'),
    },
  ]
  return (
    <Col className='min-h-screen items-start mb-8xl md:mb-3'>
      <Tabs
        defaultValue={defaultValue}
        color='base'
        size='md'
        scrollable={false}
        className='w-full mt-md'
      >
        <TabsList className='w-full md:w-fit'>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className='w-full'>
            {tab.value === 'depositAndWithdraw' && (
              <BalanceContainer withoutTitle />
            )}
            {tab.value === 'sellAndBuy' && <BalanceProjectHistory />}
            {tab.value === 'transfer' && <BalanceProjectTransferHistory />}
          </TabsContent>
        ))}
      </Tabs>
    </Col>
  )
}
